import LinerPreloader from './LinerPreloader';

export default LinerPreloader;
